import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Input } from 'antd'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import * as fromCoursesActions from 'store/actions/courses.action'
import { useIsMobile } from 'hooks/useIsMobile'
import { MyCoursesTabs, paths } from 'routes/paths'
import { CoursesSummary } from '../courses-summary/Summary'
import { RequestNewCourse } from '../Buttons'
import { TabButtons } from './atoms/TabsButtons'
import styles from './MyCourses.module.scss'
import ByCategories from './molecules/ByCategories'
import ByStatus from './molecules/ByStatus'
import { LearningPaths } from './molecules/LearningPaths'

type UrlParams = {
  origin?: string
}

const MyCourses: React.FC<any> = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const { origin = MyCoursesTabs.status } = useParams<UrlParams>()
  const [activeTab, setActiveTab] = useState(
    MyCoursesTabs[MyCoursesTabs[origin]] || MyCoursesTabs.status
  )
  const isMobile = useIsMobile()

  const history = useHistory()

  useEffect(() => {
    dispatch({ type: fromCoursesActions.COURSES_GET_COUNTERS })
  }, [dispatch])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search)
    }, 1000)
    return () => clearTimeout(timer)
  }, [search])

  const inputSearch = (
    <Input.Search
      placeholder={t('home.lmsIndex.search.placeholder')}
      className={`mr-1 ${styles.search}`}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  )
  return (
    <div className={`${styles.myCoursesWrapper}`}>
      {isMobile && (
        <div className={`${styles.mobileSearchWrapper}`}>{inputSearch}</div>
      )}
      <CoursesSummary />
      {true && (
        <div>
          <TabButtons
            activeTab={activeTab}
            onChangeTab={(tab) => {
              history.push(paths.myCourses.root + '/' + tab)
              setActiveTab(tab)
            }}
          />
          {!isMobile && (
            <div className={`${styles.rightSide}`}>
              <RequestNewCourse />
              <div className={`${styles.searchWrapper}`}>{inputSearch}</div>
            </div>
          )}
          {[
            {
              index: MyCoursesTabs.status,
              element: <ByStatus search={debouncedSearch} />,
            },
            {
              index: MyCoursesTabs.categories,
              element: <ByCategories search={debouncedSearch} />,
            },
            {
              index: MyCoursesTabs.learningPaths,
              element: <LearningPaths search={debouncedSearch} />,
            },
          ].map((tab) => {
            if (activeTab === tab.index) return tab.element
            return null
          })}
        </div>
      )}
    </div>
  )
}

export default MyCourses
